export const toast = {
  success: (message: string) => {
    if ((window as any).addToast) {
      (window as any).addToast({ message, type: 'success' });
    } else {
      console.log('Toast:', message);
    }
  },
  
  error: (message: string) => {
    if ((window as any).addToast) {
      (window as any).addToast({ message, type: 'error' });
    } else {
      console.error('Error:', message);
    }
  },
  
  warning: (message: string) => {
    if ((window as any).addToast) {
      (window as any).addToast({ message, type: 'warning' });
    } else {
      console.warn('Warning:', message);
    }
  }
}; 